// Action Types
export const FETCH_ACC_BU_NUDGE_REQUEST = "FETCH_ACC_BU_NUDGE_REQUEST";
export const FETCH_ACC_BU_NUDGE_SUCCESS = "FETCH_ACC_BU_NUDGE_SUCCESS";
export const FETCH_ACC_BU_VERSION_NUDGE_SUCCESS = "FETCH_ACC_BU_VERSION_NUDGE_SUCCESS";
export const FETCH_ACC_BU_NUDGE_FAILURE = "FETCH_ACC_BU_NUDGE_FAILURE";

// Action Creators
export const fetchAccBuNudgeRequest = (data) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ACC_BU_NUDGE_REQUEST,
      payload: data,
    });
  };
};
export const fetchAccBuNudgeSuccess = (data) => ({
  type: FETCH_ACC_BU_NUDGE_SUCCESS,
  payload: data,
});
export const fetchAccBuNudgeVersionSuccess = (data) => ({
  type: FETCH_ACC_BU_VERSION_NUDGE_SUCCESS,
  payload: data,
});
export const fetchAccBuNudgeFailure = (error) => ({
  type: FETCH_ACC_BU_NUDGE_FAILURE,
  payload: error,
});
